// source: Notification.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.GMRef', null, global);
goog.exportSymbol('proto.MessageRequest', null, global);
goog.exportSymbol('proto.MessageResponse', null, global);
goog.exportSymbol('proto.PlatformEvent', null, global);
goog.exportSymbol('proto.PlatformRemoteCommand', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MessageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MessageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MessageRequest.displayName = 'proto.MessageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MessageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.MessageResponse.repeatedFields_, null);
};
goog.inherits(proto.MessageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MessageResponse.displayName = 'proto.MessageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PlatformEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PlatformEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PlatformEvent.displayName = 'proto.PlatformEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PlatformRemoteCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PlatformRemoteCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PlatformRemoteCommand.displayName = 'proto.PlatformRemoteCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GMRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.GMRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GMRef.displayName = 'proto.GMRef';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MessageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.MessageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MessageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MessageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    topic: jspb.Message.getFieldWithDefault(msg, 1, ""),
    messagecount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    sendduration: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MessageRequest}
 */
proto.MessageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MessageRequest;
  return proto.MessageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MessageRequest}
 */
proto.MessageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTopic(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMessagecount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSendduration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MessageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MessageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MessageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTopic();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessagecount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSendduration();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string topic = 1;
 * @return {string}
 */
proto.MessageRequest.prototype.getTopic = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.MessageRequest} returns this
 */
proto.MessageRequest.prototype.setTopic = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 messageCount = 2;
 * @return {number}
 */
proto.MessageRequest.prototype.getMessagecount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.MessageRequest} returns this
 */
proto.MessageRequest.prototype.setMessagecount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 sendDuration = 3;
 * @return {number}
 */
proto.MessageRequest.prototype.getSendduration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.MessageRequest} returns this
 */
proto.MessageRequest.prototype.setSendduration = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.MessageResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MessageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.MessageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MessageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MessageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    content: jspb.Message.getFieldWithDefault(msg, 1, ""),
    offset: jspb.Message.getFieldWithDefault(msg, 2, 0),
    valuesList: jspb.Message.toObjectList(msg.getValuesList(),
    proto.PlatformEvent.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MessageResponse}
 */
proto.MessageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MessageResponse;
  return proto.MessageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MessageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MessageResponse}
 */
proto.MessageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOffset(value);
      break;
    case 3:
      var value = new proto.PlatformEvent;
      reader.readMessage(value,proto.PlatformEvent.deserializeBinaryFromReader);
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MessageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MessageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MessageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MessageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.PlatformEvent.serializeBinaryToWriter
    );
  }
};


/**
 * optional string content = 1;
 * @return {string}
 */
proto.MessageResponse.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.MessageResponse} returns this
 */
proto.MessageResponse.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 offset = 2;
 * @return {number}
 */
proto.MessageResponse.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.MessageResponse} returns this
 */
proto.MessageResponse.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated PlatformEvent values = 3;
 * @return {!Array<!proto.PlatformEvent>}
 */
proto.MessageResponse.prototype.getValuesList = function() {
  return /** @type{!Array<!proto.PlatformEvent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.PlatformEvent, 3));
};


/**
 * @param {!Array<!proto.PlatformEvent>} value
 * @return {!proto.MessageResponse} returns this
*/
proto.MessageResponse.prototype.setValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.PlatformEvent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.PlatformEvent}
 */
proto.MessageResponse.prototype.addValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.PlatformEvent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.MessageResponse} returns this
 */
proto.MessageResponse.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PlatformEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.PlatformEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PlatformEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PlatformEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventtype: jspb.Message.getFieldWithDefault(msg, 1, ""),
    timestamp: jspb.Message.getFieldWithDefault(msg, 2, 0),
    platformremotecommand: (f = msg.getPlatformremotecommand()) && proto.PlatformRemoteCommand.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PlatformEvent}
 */
proto.PlatformEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PlatformEvent;
  return proto.PlatformEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PlatformEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PlatformEvent}
 */
proto.PlatformEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventtype(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestamp(value);
      break;
    case 3:
      var value = new proto.PlatformRemoteCommand;
      reader.readMessage(value,proto.PlatformRemoteCommand.deserializeBinaryFromReader);
      msg.setPlatformremotecommand(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PlatformEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PlatformEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PlatformEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PlatformEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventtype();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getPlatformremotecommand();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.PlatformRemoteCommand.serializeBinaryToWriter
    );
  }
};


/**
 * optional string eventType = 1;
 * @return {string}
 */
proto.PlatformEvent.prototype.getEventtype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PlatformEvent} returns this
 */
proto.PlatformEvent.prototype.setEventtype = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 timestamp = 2;
 * @return {number}
 */
proto.PlatformEvent.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.PlatformEvent} returns this
 */
proto.PlatformEvent.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional PlatformRemoteCommand platformRemoteCommand = 3;
 * @return {?proto.PlatformRemoteCommand}
 */
proto.PlatformEvent.prototype.getPlatformremotecommand = function() {
  return /** @type{?proto.PlatformRemoteCommand} */ (
    jspb.Message.getWrapperField(this, proto.PlatformRemoteCommand, 3));
};


/**
 * @param {?proto.PlatformRemoteCommand|undefined} value
 * @return {!proto.PlatformEvent} returns this
*/
proto.PlatformEvent.prototype.setPlatformremotecommand = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PlatformEvent} returns this
 */
proto.PlatformEvent.prototype.clearPlatformremotecommand = function() {
  return this.setPlatformremotecommand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PlatformEvent.prototype.hasPlatformremotecommand = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PlatformRemoteCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.PlatformRemoteCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PlatformRemoteCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PlatformRemoteCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    localscriptpath: jspb.Message.getFieldWithDefault(msg, 10, ""),
    localscriptcommand: jspb.Message.getFieldWithDefault(msg, 20, ""),
    gmref: (f = msg.getGmref()) && proto.GMRef.toObject(includeInstance, f),
    receivertarget: jspb.Message.getFieldWithDefault(msg, 40, ""),
    resulttext: jspb.Message.getFieldWithDefault(msg, 50, ""),
    resultcode: jspb.Message.getFieldWithDefault(msg, 60, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PlatformRemoteCommand}
 */
proto.PlatformRemoteCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PlatformRemoteCommand;
  return proto.PlatformRemoteCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PlatformRemoteCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PlatformRemoteCommand}
 */
proto.PlatformRemoteCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocalscriptpath(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocalscriptcommand(value);
      break;
    case 30:
      var value = new proto.GMRef;
      reader.readMessage(value,proto.GMRef.deserializeBinaryFromReader);
      msg.setGmref(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceivertarget(value);
      break;
    case 50:
      var value = /** @type {string} */ (reader.readString());
      msg.setResulttext(value);
      break;
    case 60:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setResultcode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PlatformRemoteCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PlatformRemoteCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PlatformRemoteCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PlatformRemoteCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocalscriptpath();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLocalscriptcommand();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getGmref();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      proto.GMRef.serializeBinaryToWriter
    );
  }
  f = message.getReceivertarget();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getResulttext();
  if (f.length > 0) {
    writer.writeString(
      50,
      f
    );
  }
  f = message.getResultcode();
  if (f !== 0) {
    writer.writeInt32(
      60,
      f
    );
  }
};


/**
 * optional string localScriptPath = 10;
 * @return {string}
 */
proto.PlatformRemoteCommand.prototype.getLocalscriptpath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.PlatformRemoteCommand} returns this
 */
proto.PlatformRemoteCommand.prototype.setLocalscriptpath = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string localScriptCommand = 20;
 * @return {string}
 */
proto.PlatformRemoteCommand.prototype.getLocalscriptcommand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.PlatformRemoteCommand} returns this
 */
proto.PlatformRemoteCommand.prototype.setLocalscriptcommand = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional GMRef gmRef = 30;
 * @return {?proto.GMRef}
 */
proto.PlatformRemoteCommand.prototype.getGmref = function() {
  return /** @type{?proto.GMRef} */ (
    jspb.Message.getWrapperField(this, proto.GMRef, 30));
};


/**
 * @param {?proto.GMRef|undefined} value
 * @return {!proto.PlatformRemoteCommand} returns this
*/
proto.PlatformRemoteCommand.prototype.setGmref = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PlatformRemoteCommand} returns this
 */
proto.PlatformRemoteCommand.prototype.clearGmref = function() {
  return this.setGmref(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PlatformRemoteCommand.prototype.hasGmref = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional string receiverTarget = 40;
 * @return {string}
 */
proto.PlatformRemoteCommand.prototype.getReceivertarget = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.PlatformRemoteCommand} returns this
 */
proto.PlatformRemoteCommand.prototype.setReceivertarget = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional string resultText = 50;
 * @return {string}
 */
proto.PlatformRemoteCommand.prototype.getResulttext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 50, ""));
};


/**
 * @param {string} value
 * @return {!proto.PlatformRemoteCommand} returns this
 */
proto.PlatformRemoteCommand.prototype.setResulttext = function(value) {
  return jspb.Message.setProto3StringField(this, 50, value);
};


/**
 * optional int32 resultCode = 60;
 * @return {number}
 */
proto.PlatformRemoteCommand.prototype.getResultcode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 60, 0));
};


/**
 * @param {number} value
 * @return {!proto.PlatformRemoteCommand} returns this
 */
proto.PlatformRemoteCommand.prototype.setResultcode = function(value) {
  return jspb.Message.setProto3IntField(this, 60, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GMRef.prototype.toObject = function(opt_includeInstance) {
  return proto.GMRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GMRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GMRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    workflowsubmissionid: jspb.Message.getFieldWithDefault(msg, 10, ""),
    rungroupid: jspb.Message.getFieldWithDefault(msg, 20, ""),
    workflowsysrunid: jspb.Message.getFieldWithDefault(msg, 30, ""),
    workflowtasksysrunid: jspb.Message.getFieldWithDefault(msg, 40, ""),
    dbid: jspb.Message.getFieldWithDefault(msg, 50, ""),
    raceteamid: jspb.Message.getFieldWithDefault(msg, 60, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GMRef}
 */
proto.GMRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GMRef;
  return proto.GMRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GMRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GMRef}
 */
proto.GMRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkflowsubmissionid(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setRungroupid(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkflowsysrunid(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkflowtasksysrunid(value);
      break;
    case 50:
      var value = /** @type {string} */ (reader.readString());
      msg.setDbid(value);
      break;
    case 60:
      var value = /** @type {string} */ (reader.readString());
      msg.setRaceteamid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GMRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GMRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GMRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GMRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkflowsubmissionid();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getRungroupid();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getWorkflowsysrunid();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getWorkflowtasksysrunid();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getDbid();
  if (f.length > 0) {
    writer.writeString(
      50,
      f
    );
  }
  f = message.getRaceteamid();
  if (f.length > 0) {
    writer.writeString(
      60,
      f
    );
  }
};


/**
 * optional string workflowSubmissionId = 10;
 * @return {string}
 */
proto.GMRef.prototype.getWorkflowsubmissionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.GMRef} returns this
 */
proto.GMRef.prototype.setWorkflowsubmissionid = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string runGroupId = 20;
 * @return {string}
 */
proto.GMRef.prototype.getRungroupid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.GMRef} returns this
 */
proto.GMRef.prototype.setRungroupid = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string workflowSysRunId = 30;
 * @return {string}
 */
proto.GMRef.prototype.getWorkflowsysrunid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.GMRef} returns this
 */
proto.GMRef.prototype.setWorkflowsysrunid = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string workflowTaskSysRunId = 40;
 * @return {string}
 */
proto.GMRef.prototype.getWorkflowtasksysrunid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.GMRef} returns this
 */
proto.GMRef.prototype.setWorkflowtasksysrunid = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional string dbId = 50;
 * @return {string}
 */
proto.GMRef.prototype.getDbid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 50, ""));
};


/**
 * @param {string} value
 * @return {!proto.GMRef} returns this
 */
proto.GMRef.prototype.setDbid = function(value) {
  return jspb.Message.setProto3StringField(this, 50, value);
};


/**
 * optional string raceTeamId = 60;
 * @return {string}
 */
proto.GMRef.prototype.getRaceteamid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 60, ""));
};


/**
 * @param {string} value
 * @return {!proto.GMRef} returns this
 */
proto.GMRef.prototype.setRaceteamid = function(value) {
  return jspb.Message.setProto3StringField(this, 60, value);
};


goog.object.extend(exports, proto);
